import { render } from "./Bibliography.vue?vue&type=template&id=5487fe77&scoped=true"
import script from "./Bibliography.vue?vue&type=script&lang=js"
export * from "./Bibliography.vue?vue&type=script&lang=js"

import "./Bibliography.vue?vue&type=style&index=0&id=5487fe77&scoped=true&lang=css"

import exportComponent from "/data/local/webspace/artflsrv04/html/philologic4.7/publicdicos/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5487fe77"]])

export default __exports__